module.exports = __webpack_public_path__ + "img/googlePlayBlack.7314fb98.png";